import { Crumb } from "@/components/bread-crumbs/Crumb";
import {
  HeadAgreementScreenParamsQuery,
  HeadAgreementScreenParamsQueryVariables,
} from "@/gql/graphql";
import { gql, useQuery } from "@apollo/client";
import { Box } from "@stenajs-webui/core";
import { BreadCrumbs } from "@stenajs-webui/elements";
import { cssColor } from "@stenajs-webui/theme";
import * as React from "react";
import { useParams } from "react-router";
import { routeFactory } from "../../../../../../RouteFactory";
import { useGetCopyToOtherCustomerBreadCrumbNameQuery } from "../../hooks/UseCopyToOtherCustomerBreadCrumbName";
import { PageHeader } from "@/components/page-header/PageHeader";

export const headAgreementScreenParamsQuery = gql`
  query HeadAgreementScreenParams($headAgreementId: ID!) {
    productPrice {
      headAgreement {
        byId(headAgreementId: $headAgreementId) {
          headAgreementNumber
        }
      }
    }
  }
`;

export const CopyHaToOtherCustomerHeader: React.FC = () => {
  const { customerId, headAgreementId } = useParams() as {
    customerId: string;
    headAgreementId: string;
  };
  const { data } = useQuery<
    HeadAgreementScreenParamsQuery,
    HeadAgreementScreenParamsQueryVariables
  >(headAgreementScreenParamsQuery, {
    variables: { headAgreementId },
    fetchPolicy: "network-only",
  });
  const headAgreementNumber =
    data?.productPrice.headAgreement.byId?.headAgreementNumber;

  const { breadCrumbName } =
    useGetCopyToOtherCustomerBreadCrumbNameQuery(customerId);

  return (
    <Box>
      <PageHeader
        title={"Copy to other customer"}
        breadcrumbs={
          <BreadCrumbs>
            <Crumb
              path={routeFactory.productAndPrice.customer.customer({
                customerId,
              })}
              label={breadCrumbName}
            />

            <Crumb
              label={String(headAgreementNumber ?? "")}
              path={routeFactory.productAndPrice.customer.customerHeadAgreement(
                {
                  customerId,
                  headAgreementId: headAgreementId ?? "",
                }
              )}
            />
            <Crumb label={"Copy HA to other customer"} />
          </BreadCrumbs>
        }
      />
    </Box>
  );
};
